/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ra_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With a vowel-group heuristic that adjusts for a silent ending e — fast and good for scoring, but an estimate rather than a dictionary lookup, so unusual words may be slightly off.`)
};

const es_ra_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con una heurística de grupo de vocales que se ajusta a la letra e muda al final — rápido y bueno para la puntuación, pero una estimación en lugar de una búsqueda en diccionario, por lo que las palabras inusuales pueden estar ligeramente desviadas.`)
};

const de_ra_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit einer Heuristik, die Vokalgruppen zählt und ein stummes End-e berücksichtigt — schnell und gut geeignet für die Bewertung, aber eine Schätzung statt eines Wörterbuch-Nachschlags, sodass ungewöhnliche Wörter leicht abweichen können.`)
};

const nl_ra_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Met een klinkergroepheuristiek die aanpassingen doet voor een stille uitgang e — snel en goed voor scoren, maar een schatting in plaats van een woordenboekopzoeking, dus ongebruikelijke woorden kunnen licht afwijken.`)
};

const fr_ra_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avec une heuristique de groupe de voyelles qui s'ajuste pour un 'e' muet de fin — rapide et bon pour la notation, mais une estimation plutôt qu'une recherche dans un dictionnaire, donc les mots inhabituels peuvent être légèrement inexacts.`)
};

const it_ra_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con un'euristica di gruppo di vocali che si adatta a una 'e' finale silenziosa — veloce e buono per il punteggio, ma una stima piuttosto che una ricerca nel dizionario, quindi le parole insolite potrebbero essere leggermente imprecise.`)
};

const pt_br2_ra_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com uma heurística de grupo de vogais que se ajusta para um 'e' silencioso final — rápida e boa para pontuação, mas uma estimativa em vez de uma consulta de dicionário, portanto palavras incomuns podem estar ligeiramente incorretas.`)
};

const pt_ra_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com uma heurística de grupos de vogais que se ajusta para uma letra final silenciosa — rápido e bom para pontuação, mas uma estimativa em vez de uma pesquisa de dicionário, portanto palavras incomuns podem estar ligeiramente incorretas.`)
};

const ja_ra_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`母音グループの発見的手法を使用し、無音のeの終わりを調整します。スコアリングは高速で良好ですが、辞書の検索ではなく推定値であるため、珍しい単語はわずかにずれる場合があります。`)
};

const zh_ra_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`采用基于元音组的启发式算法，并针对不发音的结尾字母 e 做了调整——速度快，适合用于打分，但属于估算而非词典查询，因此少数生僻词的统计可能略有偏差。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ra_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ra_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ra_faq2_a", locale)
	if (locale === "en") return en_ra_faq2_a(inputs)
	if (locale === "es") return es_ra_faq2_a(inputs)
	if (locale === "de") return de_ra_faq2_a(inputs)
	if (locale === "nl") return nl_ra_faq2_a(inputs)
	if (locale === "fr") return fr_ra_faq2_a(inputs)
	if (locale === "it") return it_ra_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_ra_faq2_a(inputs)
	if (locale === "pt") return pt_ra_faq2_a(inputs)
	if (locale === "ja") return ja_ra_faq2_a(inputs)
	return zh_ra_faq2_a(inputs)
};